import EpdServiceClient from "../../api/EpdServiceClient";

//GET
export async function getOwners() {
  const response = await EpdServiceClient.get("api/owner");

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
export async function getOwnerById(id: string) {
  const response = await EpdServiceClient.get("api/owner/" + id);

  if (response.status === 200) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}

// POST
export async function createOwner(owner: object) {
  const response = await EpdServiceClient.post("api/owner/create", owner);

  if (response.status === 201) {
    return response.data;
  } else {
    return {
      status: response.status,
      message: response.statusText,
    };
  }
}
